<template>
  <div
    class="bbp-reminder-panel-form"
    @mouseover.stop="mouseover"
  >
    <BBPReminderPanelFormDate
      :valueObj="valueObj"
      :defaultBody="defaultBody"
      :isError.sync="errorTime"
    />
    <BBPCheckbox
      class="bbp-timer-modal-body__checkbox"
      title="Repeat"
      :defaultValue="valueObj.repeat"
      @change="onChangeRepeat"
    />
    <BBPReminderPanelFormRecur
      v-if="valueObj.repeat"
      :valueObj="valueObj"
    />
    <div>
      <div class="bbp-reminder-panel-form__label">
        User
      </div>
      <BBPAddUserSelect
        class="bbp-reminder-panel-form__select"
        :class="[
          'bbp-reminder-panel-form__select_less'
        ]"
        :row="valueObj"
        :column="usersSettings"
        @updateProject="onChangeUser"
      />
    </div>
    <div>
      <div class="bbp-reminder-panel-form__label">
        Note
      </div>
      <BBPTextarea
        :input="textAreaSettings"
        :model="valueObj"
        :errorText="textAreaSettings.errorText"
        @input="onChangeTextarea"
      />
    </div>
    <div class="bbp-reminder-panel-form-bottom">
      <button
        class="bbp-button bbp-button_border bbp-button_border_gray"
        @click="onCansel"
      >
        cancel
      </button>
      <button
        class="bbp-button"
        :disabled="disabledButton"
        @click="onButtonAdd"
      >
        {{ buttonName }}
      </button>
    </div>
  </div>
</template>

<script>
import BBPReminderPanelFormDate from
  '@/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelForm/BBPReminderPanelFormDate'
import BBPReminderPanelFormRecur from
  '@/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelForm/BBPReminderPanelFormRecur'
import BBPTextarea from '@/components/Main/BBPForm/BBPTextarea/BBPTextarea'
import BBPCheckbox from '@/components/Main/InputFields/BBPCheckbox/BBPCheckbox'
import moment from 'moment'
import convertToLocationDate from '@/mixin/convertToLocationDate'
import filterByDepartment from '@/mixin/filterByDepartment'
import sortByDate from '@/mixin/sortByDate'
import {
  RECUR_REMINDERS,
  RECUR_REMINDER_NO_REPEAT_ID,
  RECUR_RADIO_NEVER,
  RECUR_RADIO_ON,
  RECUR_REMINDERS_DAILY,
  REMINDER_STATUS
} from '@/constants/recurReminders'
import {departmentCategory} from '@/constants/departmentCategory'
import BBPAddUserSelect from '@/components/Main/BBPTable/BBPAddUserSelect/BBPAddUserSelect'
import ReminderApi from '@/api/Reminders/api'
import { LOCALHOST_DOMAIN_ID } from '@/constants/domainListPlatform'

export default {
  name: 'BBPReminderPanelForm',
  components: {
    BBPReminderPanelFormDate,
    BBPReminderPanelFormRecur,
    BBPCheckbox,
    BBPTextarea,
    BBPAddUserSelect
  },
  mixins: [convertToLocationDate, sortByDate, filterByDepartment],
  props: {
    isShowForm: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    defaultBody: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    textAreaSettings: {
      model: 'comment',
      title: 'Comment',
      height: '115px',
      placeholder: 'Enter text...',
      errorText: ''
    },
    usersSettings: {
      prop: 'targetUser',
      items: [],
      isMulti: true
    },
    valueObj: {
      comment: '',
      status: 0,
      repeat: false,
      reminderDate: new Date(),
      endDate: new Date(),
      ends: RECUR_RADIO_NEVER,
      time: '',
      targetUser: []
    },
    disabledButton: false,
    errorTime: false
  }),
  computed: {
    currentDomain () {
      return this.$store.getters.currentDomain
    },
    buttonName () {
      const { _id } = this.defaultBody
      return _id ? 'save' : 'add'
    },
    isShow: {
      get () {
        return this.isShowForm
      },
      set (data) {
        this.$emit('update:isShowForm', data)
      }
    },
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      },
      set (data) {
        this.$store.dispatch('setUsersListProjects', data)
      }
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    reminders: {
      get () {
        return this.$store.getters.reminders
      },
      set (data) {
        this.$store.dispatch('setReminders', data)
      }
    }
  },
  methods: {
    onChangeRepeat ({ value }) {
      this.valueObj = {
        ...this.valueObj,
        repeat: value,
        ends: RECUR_RADIO_NEVER
      }
    },
    mouseover () {
      this.$store.dispatch('setPickerOpen', true)
    },
    onChangeUser ({ row, value }) {
      const { targetUser } = row
      this.valueObj.targetUser = targetUser
      this.valueObj.targetUsersIds = value
    },
    onChangeTextarea (comment) {
      this.valueObj.comment = comment
    },
    onCansel () {
      this.isShow = false
    },
    createDateBackEnd (d, t) {
      const time = t || moment().set('hour', 8).set('minute', 0).format('hh:mm A')
      const newTime = moment(time, ['hh:mm A']).format('HH:mm:ss')
      const date = moment(d).format('YYYY-MM-DD')
      const fullDate = `${date}T${newTime}`
      return this.convertToLocationDate(fullDate)
    },
    createBody () {
      const {
        ends,
        time,
        endDate,
        reminderDate,
        status,
        repeat,
        targetUsersIds,
        ...all
      } = this.valueObj

      const { _id, company } = this.row
      const { reminderStatus } = this.column
      const isProjectReminder = REMINDER_STATUS.PROJECT === reminderStatus
      return {
        ...all,
        reminderDate: this.createDateBackEnd(reminderDate, time),
        status: repeat ? status.id : RECUR_REMINDER_NO_REPEAT_ID,
        endDate: RECUR_RADIO_NEVER.id === ends || !repeat ? undefined : this.createDateBackEnd(endDate, time),
        targetUser: targetUsersIds || [],
        currentDate: new Date(),
        user: this.userInfo ? this.userInfo.id : '5e09ca1d0e8c600011e57b71',
        project: isProjectReminder ? [_id] : undefined,
        request: isProjectReminder ? undefined : [_id],
        instanceStatus: reminderStatus,
        company,
        domain: this.currentDomain ? this.currentDomain.id : LOCALHOST_DOMAIN_ID
      }
    },
    isError () {
      const { time, reminderDate } = this.valueObj
      if (!time) return
      const data = this.createDateBackEnd(reminderDate, time)
      const currentDate = new Date()
      this.errorTime = currentDate > data
    },
    onButtonAdd () {
      const { _id } = this.defaultBody
      this.isError()
      const body = this.createBody()
      const { comment = '' } = body
      if (!comment) {
        this.textAreaSettings.errorText = 'mandatory field'
        this.disabledButton = true
        return
      }
      if (this.errorTime) return
      if (_id) {
        this.onEditReminder(body, _id)
        return
      }
      this.createReminder(body)
    },
    async createReminder (body) {
      try {
        const { data } = await ReminderApi.createReminder(body)
        this.reminders = this.sortByDate([...this.reminders, data], 'nextReminder')
        this.isShow = false
      } catch (err) {
        console.error(err)
      }
    },
    async onEditReminder (body, _id) {
      const index = this.reminders.findIndex((el) => el._id === _id)
      this.reminders.splice(index, 1)
      try {
        const { data } = await ReminderApi.onEditReminder(body, _id)
        this.reminders = this.sortByDate([...this.reminders, data], 'nextReminder')
        this.isShow = false
      } catch (err) {
        console.error(err)
      }
    },
    setDefaultValue () {
      const {
        comment,
        targetUser = [],
        status,
        endDate,
        reminderDate
      } = this.defaultBody

      const repeat = RECUR_REMINDER_NO_REPEAT_ID !== status
      this.valueObj = {
        ...this.valueObj,
        comment,
        targetUser,
        status: repeat ? RECUR_REMINDERS.find(({id}) => id === status) : RECUR_REMINDERS_DAILY,
        ends: endDate ? RECUR_RADIO_ON : RECUR_RADIO_NEVER,
        targetUsersIds: targetUser.map((el) => el._id),
        repeat,
        reminderDate,
        endDate: endDate || new Date()
      }
    }
  },
  watch: {
    'valueObj.comment' (newVal) {
      if (newVal) {
        this.textAreaSettings.errorText = false
        this.disabledButton = false
      }
    }
  },
  beforeMount () {
    const { _id } = this.defaultBody
    if (_id) this.setDefaultValue()
    const { PROJECT_MANAGER } = departmentCategory
    this.usersSettings.items = this.sortUsersByDepartment(this.usersListProjects, PROJECT_MANAGER)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bbp-reminder-panel-form {
    display: grid;
    grid-gap: 17px 0;
    padding: 22px 18px 0 18px;

    &__label {
      margin: 0 0 8px 0;
      font-size: 13px;
      line-height: 16px;
      font-weight: 600;
      color: $color-denim;
    }

    &__select {
      justify-content: flex-start !important;
    }
  }

  .bbp-reminder-panel-form-bottom {
    display: grid;
    grid-template-columns: repeat(2, 72px);
    grid-gap: 0 5px;
    justify-content: end;
    padding: 0 0 20px 0;
    border-bottom: 1px solid $color-wild-sand;

    .bbp-button {
      height: 32px;
      font-size: 11px;
      line-height: 13px;
      padding: 0;

      &:last-child {
        width: 65px;
        margin: 0 0 0 7px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelForm/BBPReminderPanelForm.vue